import React from "react"
import { Text, StyleSheet } from "@react-pdf/renderer"

const styles = StyleSheet.create({
	footer: {
		marginTop: "auto",
		textAlign: "left",
		fontSize: 8,
		color: "#64748B",
	},
})

export const ReportFooter: React.FC = () => (
	<Text style={styles.footer}>
		This report is generated by MileKeeper AI 
	</Text>
)
